// Enhanced Mega Menu JavaScript

class EnhancedMegaMenu {
  constructor() {
    this.megaMenus = document.querySelectorAll('.mega-menu');
    this.activeMenu = null;
    this.hoverTimeout = null;
    this.init();
  }

  init() {
    this.megaMenus.forEach(menu => {
      this.setupMenu(menu);
    });
    
    // Close mega menu when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mega-menu')) {
        this.closeAllMenus();
      }
    });

    // Close mega menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllMenus();
      }
    });
  }

  setupMenu(menu) {
  const summary = menu.querySelector('summary');
  const content = menu.querySelector('.mega-menu__content');
  const header = document.querySelector('.header'); // or adjust if needed

  if (!summary || !content || !header) return;

  let hoverTimeout = null;

  const handleHoverLeave = () => {
    hoverTimeout = setTimeout(() => {
      // Only close if not hovering over menu OR header
      if (!menu.matches(':hover') && !header.matches(':hover')) {
        this.closeMenu(menu);
      }
    }, 200);
  };

  const handleHoverEnter = () => {
    clearTimeout(hoverTimeout);
    this.openMenu(menu);
  };

  // Only open when hovering the menu itself
  menu.addEventListener('mouseenter', handleHoverEnter);
  menu.addEventListener('mouseleave', handleHoverLeave);

  // Don't open if hovering header — just prevent closing
  header.addEventListener('mouseleave', handleHoverLeave);
  header.addEventListener('mouseenter', () => {
    clearTimeout(hoverTimeout); // Cancel any close while in header
  });

  this.addLoadingState(content);
  this.addFeaturedContent(content);
  this.setupMobileScroll(content);
}


openMenu(menu) {
  if (this.activeMenu === menu && menu.hasAttribute('open')) {
    // Menu is already open and active — don't re-open or re-animate
    return;
  }

  this.closeAllMenus();
  menu.setAttribute('open', '');
  this.activeMenu = menu;

  // Only animate if menu was not already open
  this.animateMenuItems(menu);
}

  closeMenu(menu) {
    menu.removeAttribute('open');
    if (this.activeMenu === menu) {
      this.activeMenu = null;
    }
  }

  closeAllMenus() {
    this.megaMenus.forEach(menu => {
      this.closeMenu(menu);
    });
  }

  animateMenuItems(menu) {
    const items = menu.querySelectorAll('.mega-menu__link');
    items.forEach((item, index) => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(10px)';
      
      setTimeout(() => {
        item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      }, index * 50);
    });
  }

  addLoadingState(content) {
    // Add loading spinner for dynamic content
    if (!content.querySelector('.mega-menu__spinner')) {
      const spinner = document.createElement('div');
      spinner.className = 'mega-menu__spinner';
      spinner.style.display = 'none';
      content.appendChild(spinner);
    }
  }

  addFeaturedContent(content) {
    // Add featured content section if it doesn't exist
    const list = content.querySelector('.mega-menu__list');
    if (list && !list.querySelector('.mega-menu__featured')) {
      const lastColumn = list.querySelector('li:last-child');
      if (lastColumn) {
        const featured = document.createElement('div');
        featured.className = 'mega-menu__featured';
        lastColumn.appendChild(featured);
      }
    }
  }

  setupMobileScroll(content) {
    // Smooth scrolling for mobile mega menu
    let isScrolling = false;
    
    content.addEventListener('scroll', () => {
      if (!isScrolling) {
        window.requestAnimationFrame(() => {
          // Add scroll shadow effects
          const scrollTop = content.scrollTop;
          const scrollHeight = content.scrollHeight;
          const clientHeight = content.clientHeight;
          
          if (scrollTop > 10) {
            content.classList.add('mega-menu--scrolled');
          } else {
            content.classList.remove('mega-menu--scrolled');
          }
          
          if (scrollTop < scrollHeight - clientHeight - 10) {
            content.classList.add('mega-menu--has-more');
          } else {
            content.classList.remove('mega-menu--has-more');
          }
          
          isScrolling = false;
        });
      }
      isScrolling = true;
    });
  }
}

// Search functionality within mega menu
class MegaMenuSearch {
  constructor() {
    this.searchInput = null;
    this.createSearchInput();
  }

  createSearchInput() {
    const megaMenus = document.querySelectorAll('.mega-menu__content');
    
    megaMenus.forEach(content => {
      if (!content.querySelector('.mega-menu__search')) {
        const searchContainer = document.createElement('div');
        searchContainer.className = 'mega-menu__search';
        searchContainer.innerHTML = `
          <input type="text" 
                 class="mega-menu__search-input" 
                 placeholder="Search categories..."
                 autocomplete="off">
        `;
        
        content.insertBefore(searchContainer, content.firstChild);
        
        const searchInput = searchContainer.querySelector('.mega-menu__search-input');
        this.setupSearch(searchInput, content);
      }
    });
  }

  setupSearch(input, content) {
    let searchTimeout;
    
    input.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        this.performSearch(e.target.value, content);
      }, 300);
    });
  }

  performSearch(query, content) {
    const links = content.querySelectorAll('.mega-menu__link');
    const lowerQuery = query.toLowerCase();
    
    links.forEach(link => {
      const text = link.textContent.toLowerCase();
      if (query === '' || text.includes(lowerQuery)) {
        link.classList.toggle('highlighted', query !== '' && text.includes(lowerQuery));
      } else {
        link.classList.remove('highlighted');
      }
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new EnhancedMegaMenu();
  new MegaMenuSearch();
});

// Add custom CSS for search and scroll effects
const additionalStyles = `
<style>
.mega-menu__search {
  padding: 1rem 2rem 0;
  border-bottom: 1px solid rgba(var(--color-foreground), 0.1);
  margin-bottom: 1rem;
}

.mega-menu__search-input {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(var(--color-foreground), 0.2);
  border-radius: 6px;
  font-size: 1.4rem;
  background: rgba(var(--color-background), 0.8);
  transition: all 0.3s ease;
}

.mega-menu__search-input:focus {
  outline: none;
  border-color: rgb(var(--color-base-accent-1));
  box-shadow: 0 0 0 2px rgba(var(--color-base-accent-1), 0.2);
}

.mega-menu--scrolled::before {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.mega-menu--has-more::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(transparent, rgba(var(--color-background), 0.9));
  pointer-events: none;
}

@media screen and (max-width: 990px) {
  .mega-menu__search {
    display: none;
  }
}
</style>
`;

document.head.insertAdjacentHTML('beforeend', additionalStyles);